/*
    Author:SMG
    Time:2016-01-19
*/
'use strict';
angular.module('productManageMentEditNameModule', [])
    .controller('productManageMentEditNameCtrl', ['$scope', '$stateParams', '$validation', '$q', '$modalInstance', 'trsHttpService', 'initSingleSelecet', 'modalDialog', 'selectedItem', 'trsTransferService', 'trsspliceString', 'localStorageService', '$sessionStorage', function($scope, $stateParams, $validation, $q, $modalInstance, trsHttpService, initSingleSelecet, modalDialog, selectedItem, trsTransferService, trsspliceString, localStorageService, $sessionStorage) {
        initStatus();
        initData();

        function initStatus() {
            $scope.params = {
                'serviceid': 'mlf_paperset',
                'methodname': 'findBanMianById',
                'ChannelId': selectedItem.CHANNELID
            };

            /* if (angular.isDefined(selectedItem)) {
                $scope.selectedItem = angular.copy(selectedItem);
            }*/
        }

        function initData() {
            if (angular.isDefined(selectedItem)) {
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.params, 'get').then(function(data) {
                    $scope.selectedItem = {
                        ChnlDesc: data.CHNLDESC,
                        SimpleName: data.SIMPLENAME,
                        DieCiId: data.DIECIID,
                        ObjectId: data.CHANNELID,
                        SiteId: $stateParams.paper,
                        categoryName: data.CATEGORYNAME,
                        categoryId: data.CATEGORYID
                    };
                    $scope.roles = data.ROLES;
                    initNews();
                    initClassifyDroplist();
                    dieciDroplist();
                });
            } else {
                initNews();
                dieciDroplist();
            }
        }

        function initNews() {
            $scope.params.serviceid = 'mlf_paperset';
            $scope.params.methodname = 'findPaperById';
            $scope.params.SiteId = $stateParams.paper;
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.params, 'get').then(function(data) {
                $scope.paper = data;
            });
        }
        // 保存
        $scope.save = function() {
            save().then(function(data) {
                $modalInstance.close('save');
            });

        };

        // 保存并新建
        $scope.saveNew = function() {
            save().then(function(data) {
                $modalInstance.close();
            });
        };

        // 取消
        $scope.cancel = function() {
            $modalInstance.dismiss();
        };

        function save() {
            var deferred = $q.defer();
            $validation.validate($scope.ZPLayoutForm).success(function() {
                $scope.selectedItem.serviceid = 'mlf_paperset';
                $scope.selectedItem.methodname = 'saveCaiBianBanMian';
                $scope.selectedItem.CategoryId = $scope.classifyDroplistSelected.value;
                $scope.selectedItem.RoleIds = trsspliceString.spliceString($scope.roles, 'ROLEID', ',');
                $scope.selectedItem.SiteId = $stateParams.paper;
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.selectedItem, 'get').then(function(data) {
                    deferred.resolve();
                });
            }).error(function() {
                $scope.showAllTips = true;
                modalDialog.alertType('提交失败', '请填写必填项', 'error', false, function() {});
            });
            return deferred.promise;
        }
        $scope.distribAuthority = function() {
            // var userInfo = localStorageService.get('mlfCachedUser'); // session改变
            var userInfo = $sessionStorage.get('mlfCachedUser');
            var groupId = userInfo.GroupId;
            trsTransferService.getRole('权限设置', groupId, '', $scope.roles, function(data) {
                $scope.roles = data;
            });
        };

        $scope.delRole = function (role) {
            var sp = $scope.roles.indexOf(role);
            if (sp != -1){
                $scope.roles.splice(sp, 1);
            }
        };

        // 初始化叠次下拉框
        function dieciDroplist() {
            var params = {
                'serviceid': 'mlf_paperset',
                'methodname': 'queryDieCis',
                'PaperId': $stateParams.paper,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                var dieciDroplistJson = data;
                var options = [];
                for (var key in dieciDroplistJson) {
                    options.push({
                        name: dieciDroplistJson[key].CHNLDESC,
                        value: dieciDroplistJson[key].CHANNELID
                    });
                }
                $scope.dieciDroplistJson = options;
                for (var i = 0;i < options.length;i++){
                    if (options[i].value == $scope.selectedItem.DieCiId){
                        $scope.dieciDroplistSelected = angular.copy($scope.dieciDroplistJson[i]);
                        $scope.selectedItem.DieCiId = $scope.dieciDroplistSelected.value;
                    }
                }

            });
        }
        $scope.getDieciData = function() {
            $scope.selectedItem.DieCiId = $scope.dieciDroplistSelected.value;
        };


        // 初始化分类下拉框
        function initClassifyDroplist() {
            var params = {
                'serviceid': 'mlf_paperset',

                /* "methodname": "queryCaiBianCategory",*/
                'methodname': 'queryCaiBianCategoryWithoutRight',
                'PaperId': $stateParams.paper,
            };

            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                var classifyDroplistJson = data;
                var options = [];
                var index;
                for (var key in classifyDroplistJson) {
                    options.push({
                        name: classifyDroplistJson[key].CATEGORYNAME, // 分类名称
                        value: classifyDroplistJson[key].CAIBIANCATEGORYID // 分类id
                    });
                    if ($scope.selectedItem.categoryId == classifyDroplistJson[key].CAIBIANCATEGORYID) {
                        index = key;
                    }
                }
                $scope.classifyDroplistJson = options;
                $scope.classifyDroplistSelected = index ? angular.copy($scope.classifyDroplistJson[index]) : angular.copy($scope.classifyDroplistJson[0]);
            });
        }
        $scope.getClassifyData = function() {
            $scope.selectedItem.categoryId = $scope.classifyDroplistSelected.value;
        };


    }])
    .controller('productManageMentNewPageEditingCtrl', ['$scope', '$stateParams', '$validation', '$q', '$modalInstance', 'trsHttpService', 'initSingleSelecet', 'modalDialog', 'initManageConSelectedService', 'trsTransferService', 'params', 'trsspliceString', 'localStorageService', '$sessionStorage', function($scope, $stateParams, $validation, $q, $modalInstance, trsHttpService, initSingleSelecet, modalDialog, initManageConSelectedService, trsTransferService, params, trsspliceString, localStorageService, $sessionStorage) {
        initStatus();
        initData();

        function initData() {
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.params, 'get').then(function(data) {
                $scope.paper = data;
                dieciDroplist();
                initClassifyDroplist();
            });
        }
        $scope.delRole = function (role) {
            var sp = $scope.roles.indexOf(role);
            if (sp != -1){
                $scope.roles.splice(sp, 1);
            }
        };
        function initStatus() {
            $scope.params = {
                'serviceid': 'mlf_paperset',
                'methodname': 'findPaperById',
                'SiteId': $stateParams.paper
            };
            $scope.selectedItem = {
                ChnlDesc: params.banmian ? params.banmian : '',
                SimpleName: params.jianchen ? params.jianchen : '',
            };
        }
        $scope.distribAuthority = function() {
            // var userInfo = localStorageService.get('mlfCachedUser'); // session改变
            var userInfo = $sessionStorage.get('mlfCachedUser');
            var groupId = userInfo.GroupId;
            trsTransferService.getRole('权限设置', groupId, '', [], function(data) {
                $scope.roles = data;
            });
        };
        $scope.getDieciData = function() {
            $scope.params.DieCiId = $scope.dieciDroplistSelected.value;
        };

        // 保存
        $scope.save = function() {
            save().then(function(data) {
                $modalInstance.close('save');
            });
        };

        // 取消
        $scope.cancel = function() {
            $modalInstance.dismiss();
        };

        // 保存并新建
        $scope.saveNew = function() {
            save().then(function(data) {
                $modalInstance.close({
                    'dieci': $scope.dieciDroplistSelected.value,
                    'banmian': $scope.selectedItem.ChnlDesc,
                    'jianchen': $scope.selectedItem.SimpleName
                });
            });
        };

        function save() {
            var deferred = $q.defer();
            $validation.validate($scope.ZPLayoutForm).success(function() {
                $scope.params.serviceid = 'mlf_paperset';
                $scope.params.methodname = 'saveCaiBianBanMian';
                $scope.params.ObjectId = 0;
                $scope.params.RoleIds = trsspliceString.spliceString($scope.roles, 'ROLEID', ',');
                $scope.params.ChnlDesc = $scope.selectedItem.ChnlDesc;
                $scope.params.SimpleName = $scope.selectedItem.SimpleName;
                $scope.params.SiteId = $stateParams.paper;
                $scope.params.DieCiId = $scope.dieciDroplistSelected.value;
                $scope.params.CategoryId = $scope.classifyDroplistSelected.value;
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.params, 'get').then(function(data) {
                    deferred.resolve();
                });
            }).error(function() {
                $scope.showAllTips = true;
                modalDialog.alertType('提交失败', '请填写必填项', 'error', false, function() {});
            });
            return deferred.promise;
        }

        // 初始化叠次下拉框
        function dieciDroplist() {
            $scope.params = {
                'serviceid': 'mlf_paperset',
                'methodname': 'queryDieCis',
                'PaperId': $stateParams.paper,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.params, 'post').then(function(data) {
                var dieciDroplistJson = data;
                var options = [];
                var index;
                for (var key in dieciDroplistJson) {
                    options.push({
                        name: dieciDroplistJson[key].CHNLDESC,
                        value: dieciDroplistJson[key].CHANNELID
                    });
                    if (params.dieci !== '' && dieciDroplistJson[key].CHANNELID == params.dieci) {
                        index = key;
                    }
                }
                $scope.dieciDroplistJson = options;
                $scope.dieciDroplistSelected = index ? angular.copy($scope.dieciDroplistJson[index]) : angular.copy($scope.dieciDroplistJson[0]);
            });
        }

        // 初始化分类下拉框
        function initClassifyDroplist() {
            var params = {
                'serviceid': 'mlf_paperset',

                /* "methodname": "queryCaiBianCategory",*/
                'methodname': 'queryCaiBianCategoryWithoutRight',
                'PaperId': $stateParams.paper,
            };

            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                var classifyDroplistJson = data;
                var options = [];
                var index;
                for (var key in classifyDroplistJson) {
                    options.push({
                        name: classifyDroplistJson[key].CATEGORYNAME, // 分类名称
                        value: classifyDroplistJson[key].CAIBIANCATEGORYID // 分类id
                    });

                    /* if (params.dieci !== "" && classifyDroplistJson[key].CAIBIANCATEGORYID == params.dieci) {
                        index = key;
                    }*/
                }
                $scope.classifyDroplistJson = options;
                $scope.classifyDroplistSelected = index ? angular.copy($scope.classifyDroplistJson[index]) : angular.copy($scope.classifyDroplistJson[0]);
            });
        }
        $scope.getClassifyData = function() {
            $scope.params.CategoryId = $scope.classifyDroplistSelected.value;
        };
    }]);
